import React from 'react';
import SidebarLayout from './SidebarLayout';

const UserLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const items = [
    { label: 'Dashboard', to: '/dashboard', end: true },
    { label: 'Orders', to: '/orders' },
    { label: 'Wallet', to: '/wallet' },
    { label: 'Messages', to: '/messages' },
  ];

  return (
    <SidebarLayout
      title="My Account"
      subtitle="Manage your membership"
      items={items}
    >
      {children}
    </SidebarLayout>
  );
};

export default UserLayout;
